export const getAuthOptions = token =>
  token ? { headers: { Authorization: `Bearer ${token}` } } : {};
